module.exports = function() {
  return new Worker(__webpack_public_path__ + "ab51ce7f7b8dd938381d.worker.js");
};